import { takeLeading } from 'redux-saga/effects';
import { GET_SURVEY_BRAND } from './types';
import { getSurveyBrand } from './sagas/getSurveyBrand';

function* getSurveyBrandWatcher() {
	yield takeLeading(GET_SURVEY_BRAND, getSurveyBrand);
}

export const surveyBrandWatchers = [getSurveyBrandWatcher];
